import {
  FormElementProps,
  FormElementRenderProps,
  isValid,
} from "react-forms-state/src";
import { Checkbox, CheckboxProps } from "./checkbox";

export function ConnectedCheckbox({
  debug,
  name,
  onChange,
  sideMutation,
  validation,
  value,
  withFlatModel,
  ...inputProps
}: Omit<FormElementProps, "elementName"> & CheckboxProps) {
  return (
    <FormElementRenderProps
      debug={debug}
      elementName={name}
      sideMutation={sideMutation}
      validation={validation}
      withFlatModel={withFlatModel}
      onChange={onChange}
    >
      {({ onChange, validation, value: formValue }) => {
        return (
          <Checkbox
            {...inputProps}
            ref={inputProps.ref as any}
            isInvalid={!isValid(validation) || inputProps.isInvalid}
            isSelected={
              value
                ? JSON.stringify(formValue) === JSON.stringify(value)
                : !!formValue
            }
            value={value}
            onValueChange={(checked) => {
              onChange(value ? (checked ? value : checked) : checked);
              inputProps.onValueChange?.(value);
            }}
          />
        );
      }}
    </FormElementRenderProps>
  );
}

ConnectedCheckbox.displayName = "RecareUI.ConnectedCheckbox";
